export default __webpack_public_path__ + "images/c83ec32a880a1e65949ea64b3c5dceb7-edmelectronic.webp";